// Libs
import axios from 'axios';
import { useHistory } from 'react-router-dom'
import { SubmissionError } from 'redux-form'

// Actions
import { changeErr, changeSuccess, changeLocalLoading } from '../App/actions'
import { reset } from 'redux-form'

// Axios
import { serverAPI } from '../../index'

// Action types
export const FORGET_PW = 'forget_pw'

export function forgetPw(reduxFormData) {
  return function (dispatch) {
    dispatch(changeLocalLoading(true))
    return serverAPI.put('/user/forget-pw', reduxFormData)
      .then(response => {
        dispatch(changeLocalLoading(false))
        dispatch(changeSuccess('Caso você seja usuário, receberá um email para redefinir sua senha.'))
        dispatch(reset('signUp'))
        // After 5000ms
        setTimeout(() => {
          // Redirect to '/login'
          document.location.href = '/login'
        }, 5000);
      })
      .catch((e) => {
        dispatch(changeLocalLoading(false))
        switch (e.response.status) {
          case 401:
            dispatch(changeErr('Usuário bloqueado. Entre em contato com nossa equipe de suporte através do chat.'))
            break
          case 404:
            dispatch(changeSuccess('Caso você seja usuário, receberá um email para redefinir sua senha.'))
            break
          default:
            dispatch(changeErr('Desculpe, os servidores então em manutenção no momento. Em algumas horas iremos retomar as atividades.'))
        }
      })
  }
}
